"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.empty = undefined;

var _EmptyObservable = require("./EmptyObservable");

var empty = exports.empty = _EmptyObservable.EmptyObservable.create;
//# sourceMappingURL=empty.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/observable/empty.js
// module id = 230
// module chunks = 0